module.exports = __webpack_public_path__ + "img/ICON_VARIATIONS.14bb7dd4.png";